import * as React from 'react';
import debounce from 'lodash.debounce';
import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TextField from "@mui/material/TextField";
import { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { fetchExtractorDetailReq } from '../../../store/extractor/actions';
import SearchIcon from '@mui/icons-material/Search';
import { Grid, InputAdornment, Stack } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import SearchListGrid from '../searchListGrid/SearchListGrid';
import * as workflows from '../../../store/workFlows/actions'
import {
    deleteExtractorPendingSelector,
    deleteExtractorSelector,
    getExtractorDetailSelector,
    getExtractorListPendingSelector,
    getExtractorListSelector,
} from "../../../store/extractor/selectors";
import {
    fetchExtractorListReq,
} from "../../../store/extractor/actions";
import { IDataExtractor, ISingleExtractorDetail, IExtractorListParams, IDeleteParams } from '../../../store/extractor/types';
import { HeadCell, Order } from '../tableGrid/types';
import EnhancedTable from '../tableGrid/tableGrid';
import EnhancedTableToolbar from '../tableGrid/tableToolbar';
import EnhancedTableHead from '../tableGrid/tableHead';
import Row from '../tableGrid/tableRow';
import { useNavigate } from 'react-router-dom';
import { deleteExtractorReq } from '../../../store/extractor/actions'
import { Button } from '@mui/material';
import CustomizedDialogs from '../../atoms/modal/customizedDialogs';
import { getPrivacyClassificationText, getSecurityClassificationText } from '../../shared/functions';
import { ISpokeDetails, ISpokeSearchParams } from '../../../store/spokes/types';
import { fetchSpokeSelector } from '../../../store/spokes/selectors';
import { getProfileSelector } from '../../../store/userProfile/selectors';
import { fetchSpokesRequest } from '../../../store/spokes/actions';
import { IProfile } from '../../../store/userProfile/types';
import {SEARCH_DEBOUNCE_TIME_MILLIS} from "../../../constants/common";
import { fetchSourceDetailsReq } from '../../../store/dataSource/actions';
import { getSourceSelector } from '../../../store/dataSource/selectors';
import { IDataSourceDetails } from '../../../store/dataSource/types';
import { OverridableStringUnion } from "@mui/types";

// settings data
const filterCells: string[] = [
    'schema', 'table', 'treatmentLevel', 'accessControl', 'sourceName', 'dataStewards', 'spokeName'
]

// end

const descendingComparator = (a: IDataExtractor, b: IDataExtractor, orderBy: keyof IDataExtractor) => {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

const getComparator = (order: Order, orderBy: keyof IDataExtractor): (
    a: IDataExtractor,
    b: IDataExtractor,
) => number => {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
};

export type ExtractorExplorerProps = {
    selectable: string;
    selectorField?: string;
    selectedValue?: any;
    onSelect?: any;
    displayIcons: boolean;
    sourceName?: string;
    displayActionButtons: boolean;
    isAdmin?: boolean;
    nonUdlTables?: boolean;
}


const ExtractorExplorer = (props: ExtractorExplorerProps) => {


    const headCells: HeadCell[] = [
        {
            id: 'inactive',
            numeric: false,
            disablePadding: true,
            label: '',
            width: "5px",
            disableSort: true
        },
        {
            id: "selected",
            numeric: false,
            disablePadding: true,
            label: "",
            width: "5px",
        },
        {
            id: 'treatmentLevel',
            numeric: false,
            disablePadding: true,
            label: '',
            width: '5px'
        },
        {
            id: 'accessControl',
            numeric: false,
            disablePadding: true,
            label: '',
            width: '5px'
        },
        {
            id: 'description',
            numeric: false,
            disablePadding: false,
            label: 'Description',
            width: '100px'
        },
        {
            id: 'tableId',
            numeric: false,
            disablePadding: false,
            label: 'Name',
            width: '170px'
        },
        {
            id: 'schema',
            numeric: false,
            disablePadding: false,
            label: 'Schema',
            width: '10px'
        },
        {
            id: 'table',
            numeric: false,
            disablePadding: false,
            label: 'Table',
            width: '150px'
        },

    ];

    const headCellsAlt: HeadCell[] = [
        {
            id: 'inactive',
            numeric: false,
            disablePadding: true,
            label: '',
            width: "5px",
            disableSort: true
        },
        {
            id: 'treatmentLevel',
            numeric: false,
            disablePadding: true,
            label: '',
            width: '5px'
        },
        {
            id: 'accessControl',
            numeric: false,
            disablePadding: true,
            label: '',
            width: '5px'
        },
        {
            id: 'description',
            numeric: false,
            disablePadding: false,
            label: 'Description',
            width: '100px'
        },
        {
            id: 'tableId',
            numeric: false,
            disablePadding: false,
            label: 'Name',
            width: '170px'
        },
        {
            id: 'schema',
            numeric: false,
            disablePadding: false,
            label: 'Schema',
            width: '10px'
        },
        {
            id: 'table',
            numeric: false,
            disablePadding: false,
            label: 'Table',
            width: '10px'
        },
        {
            id: 'spokeName',
            numeric: false,
            disablePadding: false,
            label: 'Spoke',
            width: '10px'
        },
    ];
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [dataRows, setDataRows] = useState<IDataExtractor[]>([]);
    const [totalRows, setTotalRows] = useState(0);
    const [order, setOrder] = useState<Order>("asc");
    const [orderBy, setOrderBy] = useState<keyof IDataExtractor>("description");
    const [rowDetails, setRowDetails] = useState<ISingleExtractorDetail[]>([]);
    const [selected, setSelected] = useState<readonly string[]>(props.selectedValue === undefined ? [] : [props.selectedValue]);
    const selectable: string = props.selectable;
    const selectorField: string = props.selectorField ? props.selectorField : 'tableId'
    const allSelectable: boolean = false;
    const [open, setOpen] = useState(false);
    const [rowName, setRowName] = useState('');
    const [batchCode, setBatchCode] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [isDeletePopup, setIsDeletePopup] = useState(false)
    const [isRunPopup, setIsRunPopup] = useState(false)
    const [deletedIds, setDeletedIds] = useState<string[]>([]);
    const [dataStewards, setDataStewards] = useState<string[]>([]);
    const [getSourceData, setGetSourceData] = useState<IDataSourceDetails>();

    // Filters-related
    const [schemas, setSchemas] = useState<string[]>([]);
    const [tables, setTables] = useState<string[]>([]);
    const [treatmentLevels, setTreatmentLevels] = useState<string[]>([]);
    const [accessControls, setAccessControls] = useState<string[]>([]);
    const [spokeName, setSpokeName] = useState<string[]>([]);
    const [sourceNames, setSourceNames] = useState<string[]>([]);
    const [filters, setFilters] = useState<string[]>([]);
    const [openFilters, setOpenFilters] = useState(false);
    const [deletedIdLoading, setDeletedIdLoading] = useState('')

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const deleteExtractorStatus = useSelector(deleteExtractorSelector)
    const deletePending = useSelector(deleteExtractorPendingSelector)

    // extractor list   
    const extractorList = useSelector(getExtractorListSelector);
    const loadingExtractorList = useSelector(getExtractorListPendingSelector)

    // extractor details
    const extractorDetail = useSelector(getExtractorDetailSelector);

    //source List
    const sourceData = useSelector(getSourceSelector);

    const params: IExtractorListParams = {
        skip: page * rowsPerPage,
        top: rowsPerPage,
        count: true,
        search: searchTerm,
        schema: schemas,
        table: tables,
        treatmentLevel: treatmentLevels,
        accessControl: accessControls,
        dataStewards: dataStewards,
        spokeName: spokeName,
        sourceName: sourceNames,
        orderby: `${orderBy} ${order}`,
        nonUdlTables: props.nonUdlTables
    };

    useEffect(() => {

        // When source name is available, use as filter

        if (props.sourceName) {
            let sn = sourceNames;
            sn.push(props.sourceName);
            setSourceNames(sn);
            dispatch(fetchExtractorListReq(params));
        }

    }, []);

    useEffect(() => {
        window.scrollTo(0, 0)
        dispatch(fetchExtractorListReq(params));
    }, [page, rowsPerPage, searchTerm, orderBy, order]);

    function enableStatus(enabled: boolean): OverridableStringUnion<'disabled' | 'success'> {
        if (enabled) {
            return "success";
        } else {
            return "disabled";
        }
    }

    // Calculate the higest treatment level based on column and table treatment levels
    function calculateTreamentLevel(columnTreatment: string, tableTreatment: string): string {
        const treatments = ['very-high', 'high', 'medium'];
        for (const treatment of treatments) {
            if (columnTreatment === treatment || tableTreatment === treatment) {
                return treatment;
            }
        }
        return 'low'; // If none of the above conditions match, default to 'low'
    }

    useEffect(() => {
        let data: IDataExtractor[] = extractorList.extractors;
        if (data && data.length > 0) {
            const newData = data.map((item: IDataExtractor, index: number) => {
                const status = item.enabled === null && item.taskId === null ? true : item.enabled;
                return {
                    ...item,
                    inactive: enableStatus(status),
                    treatmentLevel: calculateTreamentLevel(item.columnTreatment, item.treatmentLevel),
                    index
                };
            })
            setDataRows(newData);
        }
        else {
            setDataRows(data);
        }
        setTotalRows(extractorList.count);
    }, [extractorList]);

    useEffect(() => {

        let isDetailExists = false;
        if (extractorDetail) {
            isDetailExists = rowDetails.filter((x) => x && x.tableId === extractorDetail!.tableId).length > 0;
            if (!isDetailExists) {
                setRowDetails([...rowDetails, extractorDetail!]);
            }
        }

    }, [extractorDetail, rowDetails]);


    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleRequestSort = (
        event: React.MouseEvent<unknown>,
        property: string,
    ) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property as keyof IDataExtractor);

        dispatch(fetchExtractorListReq(params));
    };

    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            const newSelecteds = dataRows.map((n: { description: any; }) => n.description);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const deleteAllClick = () => {
        setSelected([]);
    }

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPage(0);
        setSearchTerm(e.target.value)

    }

    const handleSearchDebounce = useMemo(() => {
        return debounce(handleSearch, SEARCH_DEBOUNCE_TIME_MILLIS);
    }, []);

    const searchEl = () => {
        return (
            <TextField
                id="extractor-search"
                label="Search Extractors"
                type="search"
                fullWidth={true}
                onChange={handleSearchDebounce}
                InputProps={{
                    startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
                }}
            />
        );
    };

    const handleExpand = (row: IDataExtractor) => {
        let isExist = rowDetails.find((x) => x && x.tableId === row.tableId);

        if (!isExist) {
            // dispatch get extractor details action
            dispatch(fetchExtractorDetailReq(row.batchCode));
        }
    }

    const handleExtractorView = (row: IDataExtractor,event:React.MouseEvent<HTMLButtonElement>) => {
        const url = `/ViewDataExtractor/${row.batchCode}`;
        if(event.ctrlKey){
            window.open(url,'_blank')
        }
        else{
        navigate(url);
        }
    }

    const handleViewSource = (row: IDataExtractor,event:React.MouseEvent<HTMLButtonElement>) => {
        const url = `/ViewDataSource/${row.sourceId}`;
        if(event.ctrlKey){
            window.open(url,'_blank')
        }
        else{
        navigate(url);
        }
    }

    const handleExtractorEdit = (row: IDataExtractor,event:React.MouseEvent<HTMLButtonElement>) => {
        const url  = `/EditDataExtractor/${row.batchCode}`;
        if(event.ctrlKey){
            window.open(url,'_blank')
        }
        else{
        navigate(url);
        }
    }

    const handleClose = () => {
        setOpen(false);
    }

    const deleteParams: IDeleteParams = {
        batchCodes: [batchCode],
    };

    const filterResults = (event: React.MouseEvent<HTMLButtonElement>, filters: string[]) => {

        let newSchemas: string[] = [];
        let newTables: string[] = [];
        let newTreatments: string[] = [];
        let newAccess: string[] = [];
        let newSources: string[] = [];
        // let newOwners: string[] = [];
        let newStewards: string[] = [];
        let newSpoke: string[] = [];


        filters.forEach(item => {
            let filter: string[] = item.split(": ");
            switch (filter[0]) {
                case 'schema':
                    newSchemas.push(filter[1]);
                    setSchemas(newSchemas);
                    params.schema = newSchemas;
                    break;
                case 'table':
                    newTables.push(filter[1]);
                    setTables(newTables);
                    params.table = newTables;
                    break;
                case 'treatmentLevel':
                    newTreatments.push(filter[1]);
                    setTreatmentLevels(newTreatments);
                    params.treatmentLevel = newTreatments;
                    break;
                case 'accessControl':
                    newAccess.push(filter[1]);
                    setAccessControls(newAccess);
                    params.accessControl = newAccess;
                    break;
                // case 'owner':
                //     newOwners.push(filter[1]);
                //     setOwners(newOwners);
                //     params.owner = newOwners;
                //     break;
                case 'sourceName':
                    newSources.push(filter[1]);
                    setSourceNames(newSources);
                    params.sourceName = newSources;
                    break;
                case 'dataStewards':
                    newStewards.push(filter[1]);
                    setDataStewards(newStewards);
                    params.dataStewards = newStewards;
                    break;
                case 'spokeName':
                    newSpoke.push(filter[1]);
                    setSpokeName(newSpoke);
                    params.spokeName = newSpoke;
                    break;
                default:
                    break;
            }
        });

        setFilters(filters);
        setOpenFilters(true);
        setPage(0);

        dispatch(fetchExtractorListReq(params));

    }

    const refreshPage = () => {

        setSchemas([]);
        params.schema = [];

        setTables([]);
        params.table = [];

        setTreatmentLevels([]);
        params.treatmentLevel = [];

        setAccessControls([]);
        params.accessControl = [];

        setSourceNames([]);
        params.sourceName = [];

        setSpokeName([]);
        params.spokeName = [];

        // setOwners([])
        // params.owner = [];


        setDataStewards([])
        params.dataStewards = [];

        setFilters([]);
        setOpenFilters(false);


        setOrder('asc')
        setOrderBy("description")

        dispatch(fetchExtractorListReq(params));

    }

    const handleExtractorDelete = () => {
        setOpen(false);

        if (deleteParams.batchCodes[0] === null) {
            const tableIdconvert: IDeleteParams = {
                batchCodes: [`B_STG_STG_${rowName}`],
            };
            dispatch(deleteExtractorReq(tableIdconvert));
            setDeletedIds(item => [...item, tableIdconvert.batchCodes[0]]);
            setDeletedIdLoading(tableIdconvert.batchCodes[0])
        }
        else {
            dispatch(deleteExtractorReq(deleteParams));
            setDeletedIds(item => [...item, deleteParams.batchCodes[0]]);
            setDeletedIdLoading(deleteParams.batchCodes[0])
        }

    }

    const confirmExtractorDelete = (row: IDataExtractor) => {
        setOpen(true);
        setBatchCode(row.batchCode);
        setRowName(row.tableId);
        setIsDeletePopup(true)
        setIsRunPopup(false)
    }

    const handleExtractorRun = () => {
        const finalExtractorRun = {
            "batchCode": batchCode ? batchCode : '',
            "rebase": false
        }
        dispatch(workflows.postWorkFlowsRequest(finalExtractorRun));
        setOpen(false);
    }

    const handleExtractorRunRebase = () => {
        const finalExtractorRun = {
            "batchCode": batchCode ? batchCode : '',
            "rebase": true
        }
        dispatch(workflows.postWorkFlowsRequest(finalExtractorRun));
        setOpen(false);
    }


    const confirmExtractorRun = (row: IDataExtractor) => {
        setOpen(true);
        setBatchCode(row.batchCode);
        setRowName(row.tableId);
        setIsDeletePopup(false)
        setIsRunPopup(true)
    }

    const handleClick = (event: React.MouseEvent<unknown>, row: any) => {
        if (selectorField === 'taskId') {
            if (selected[0] === row.taskId) {
                setSelected([]);
                props.onSelect && props.onSelect([]);
            } else {
                setSelected([row.taskId]);
                props.onSelect && props.onSelect(row)
            }
        } else {
            if (selected[0] === row.tableId) {
                setSelected([]);
                props.onSelect && props.onSelect([]);
            } else {
                setSelected([row.tableId]);
                //For non UDL tables pass the table name instead of tableId
                if (row.sourceId) {
                    props.onSelect && props.onSelect(row.tableId, row.sourceId, row.sourceName)
                } else {
                    props.onSelect && props.onSelect(row.table, row.sourceId, row.sourceName)
                }
            }

        }
    }

    //    ************ spoke based access controls ****************
    const userProfile: IProfile[] = useSelector(getProfileSelector);
    const getSpokeList = useSelector(fetchSpokeSelector);

    const [spokeList, setSpokeList] = useState<ISpokeDetails[]>();

    const spokeparams: ISpokeSearchParams = {
        count: true,
        top: rowsPerPage,
        skip: 0,
        name: [],
        owner: [],
    };

    useEffect(() => {
        dispatch(fetchSpokesRequest(spokeparams));
    }, []);

    useEffect(() => {
        if (getSpokeList && getSpokeList.length > 0) {
            setSpokeList(getSpokeList);
        }
    }, [getSpokeList]);

    useEffect(() => {
        if (sourceData !== null && sourceData !== undefined) {
            setGetSourceData(sourceData);
        }
    }, [sourceData])

    //Get source spokeName and check if user belongs to that spoke
    const isSpokeAdmin = (row: IDataExtractor) => {
        if (Number(row.sourceId) !== 0) {
            dispatch(fetchSourceDetailsReq(Number(row.sourceId)));

            if (spokeList && getSourceData) {
                let spokeAdminGroupName = spokeList.find(x => x.spokeId === getSourceData.spokeId)?.adminGroupName;
                return userProfile.some(x => x.adGroupName === spokeAdminGroupName);
            }
        }

    }

    //    ************ end spoke based access controls ****************


    const tableToolBar = () => {
        return (
            <EnhancedTableToolbar numSelected={selected.length} title={'Data Extractors'} headCells={props.selectable === "no" ? headCellsAlt : headCells} filterCells={filterCells} deleteAll={deleteAllClick}
                filterResults={filterResults} refreshPage={refreshPage} currentFilters={filters} openToolbar={openFilters} />
        );
    }

    const tableHeader = () => {
        return (
            <EnhancedTableHead
                headCells={props.selectable === "no" ? headCellsAlt : headCells}
                numSelected={selected.length}
                selectable={allSelectable}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={totalRows}
                actionable={props.displayActionButtons}
            />
        );
    }

    const isSelected = (name: string) => selected.indexOf(name) !== -1;

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - totalRows) : 0;

    const tableRows = () => {

        return (
            <>
                {dataRows?.length > 0 && dataRows.slice().sort(getComparator(order, orderBy))
                    .map((row: IDataExtractor, index: number) => {
                        const isItemSelected = selectorField === 'taskId' ? isSelected(row.taskId) : isSelected(row.tableId);

                        return (
                            <Row row={row}
                                key={row.tableId}
                                headCells={props.selectable === "no" ? headCellsAlt : headCells}
                                selectable={selectable}
                                canEdit={props.displayActionButtons ? props.isAdmin || isSpokeAdmin(row) ? true : false : props.displayActionButtons}
                                canView={props.displayActionButtons}
                                canViewSource={props.displayActionButtons ? props.isAdmin ? true : false : props.displayActionButtons}
                                canDelete={props.displayActionButtons ? props.isAdmin || isSpokeAdmin(row) ? true : false : props.displayActionButtons}
                                canExpand={props.displayActionButtons}
                                canRun={props.displayActionButtons ? props.isAdmin ? true : false : props.displayActionButtons}
                                isItemSelected={isItemSelected}
                                handleClick={(event) => props.selectable === "no" ? '' : handleClick(event, row)}
                                handleExpand={handleExpand}
                                handleView={handleExtractorView}
                                handleViewSource={handleViewSource}
                                handleEdit={handleExtractorEdit}
                                handleDelete={confirmExtractorDelete}
                                handleRun={confirmExtractorRun}
                                deletedRows={deletedIds}
                                loadingIcon={deletePending}
                                deletedIdLoading={deletedIdLoading}
                                deleteId={deleteExtractorStatus}

                            >

                                {rowDetails.length > 0 &&
                                    <Box className="expand-details" sx={{ margin: 1 }}>

                                        <Grid container spacing={3}>
                                            <Grid item xs={6}>
                                                <div><span className="title">Name : </span><span style={{ wordBreak: "break-word" }}>{row.tableId ?? "None"}</span></div>
                                                <div><span className="title">Description : </span><span>{row?.description ?? "None"}</span></div>
                                                <div><span className="title">Data Stewards : </span><span>{row?.dataStewards ?? "None"}</span></div>
                                                <div><span className="title">Data Set Name : </span><span>{row.datasetName ?? "None"}</span></div>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <div><span className="title">Batch Code : </span><span style={{ wordBreak: "break-word" }}>{row.batchCode ?? "None"}</span></div>
                                                <div><span className="title">Security Classification : </span><span>{row.securityClassification ? getSecurityClassificationText(row.securityClassification) : "None"}</span></div>
                                                <div><span className="title">Privacy Classification : </span><span>{row.privacyClassification ? getPrivacyClassificationText(row.privacyClassification) : "None"}</span></div>
                                                <div><span className="title">Access Controls : </span><span>{row.accessControl ?? "None"} </span>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                }
                            </Row>
                        );
                    })}
                {emptyRows > 0 && (
                    <TableRow
                        style={{
                            height: (53) * emptyRows,
                        }}
                    >
                        <TableCell colSpan={6} />
                    </TableRow>
                )}
            </>
        );
    }


    const listGrid = () => {

        return (
            <>
                {/* adding skeleton screen on loading */}
                {loadingExtractorList ?
                    <Grid container width="100%">
                        <Grid item xs={12}>
                            <Skeleton animation="wave" height={60} />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton animation="wave" height={60} />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton animation="wave" height={60} />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton animation="wave" height={60} />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton animation="wave" height={60} />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton animation="wave" height={60} />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton animation="wave" height={60} />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton animation="wave" height={60} />
                        </Grid>
                    </Grid>

                    :
                    <EnhancedTable
                        totalRows={totalRows}
                        tableToolBar={tableToolBar()}
                        tableHeader={tableHeader()}
                        tableRows={tableRows()}
                        pagination={true}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                }
            </>
        );
    }

    return (
        <>
            <SearchListGrid searchEl={searchEl()} children={listGrid()} />
            {/* Delete Extractor */}
            {isDeletePopup || isRunPopup ? <CustomizedDialogs
                dialogHeight=''
                modalSize="md"
                key="target"
                modalTitle={isRunPopup ? "Run Extractor" : "Delete Confirmation"}
                isOpen={open}
                onClose={handleClose}
                footerAction={
                    <Stack direction="row" spacing={2}>
                        {isDeletePopup ? <Button id="1f6e424c-1384-4f95-9ecf-2a2c02d3759f" color="primary" onClick={handleExtractorDelete} autoFocus>
                            Yes
                    </Button> : ''}
                        {isRunPopup ? <>
                            <Button id="a53aff4f-1716-4732-a01d-35dcfcf5ca1a" color="primary" onClick={handleExtractorRun} autoFocus>
                                Run
                    </Button>
                            <Button id="cac20e5d-10fc-4894-b32d-518d98242f2e" color="primary" onClick={handleExtractorRunRebase} autoFocus>
                                Run (Rebase)
                    </Button>
                        </> : ''}

                        <Button id="1c752cc2-ac36-4609-965b-e810fed4be28" color="primary" onClick={handleClose}>
                            No
                    </Button>
                    </Stack>
                }
            >
                {isRunPopup ? <>Do you want to run the extractor {rowName} with rebase?</> : <>Are you sure you want to delete {rowName} ? </>}
            </CustomizedDialogs> : ''}

        </>
    );

};

export default ExtractorExplorer;